// extracted by mini-css-extract-plugin
export default {"placePinRating":"lU5_qLpjjS7x7Ws0cWDY","placePinImage":"HwB9eQg2xh7VEspAO0i7","placePinActive":"jJIokXI6anOEOPTW4Wxb","placePopup":"Qa3AHCSUE5xuRsNcuE3G"};